import clsx from 'clsx';
import React from 'react'
import styled, { css } from 'styled-components';

export const IconClose = ({onClick, className}) => {
  return (
    <CloseIcon
      className={clsx('close-icon', className)}
      onClick={onClick}
    >
      <span />
      <span />
    </CloseIcon>
  )
}

const CloseIcon = styled.div`
${({ theme }) => css`
  &.close-icon {
    position: relative;
    width: 30px;
    height: 30px;
    cursor: pointer;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: calc(100% - 10px);
      margin: 0 auto;
      height: 2px;
      border-radius: 3px;
      transform: translate(-50%, -50%);
      transition: 0.3s ease all;
      background-color: ${theme.colors.black};

      &:nth-child(1),
      &:nth-child(2) {
        top: 50%;
        opacity: 1;
      }

      &:nth-child(1) {
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &:nth-child(2) {
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
  }
`}
`;